import Service from "./service";
import TransferForm from "../pages/bond-holder/transfer-form/transfer-form";
import RegistrationForm from "../pages/bond-holder/registration-form/registration-form";
import AdminTransfers from "../pages/admin-spu/admin-transfers/admin-transfers";
import AdminInvestorRegistrations from "../pages/adcu/admin-investor-registrations/admin-investor-registrations";

import AdminListing from "../pages/admin-lo/admin-listing/admin-listing";
import AdminListingCalendar from "../pages/admin-lo/admin-listing-calendar/admin-listing-calendar";

import Transfers from "../pages/broker/transfers/transfers"
import InvestorRegistrations from "../pages/broker/investor-registration/investor-registrations";
import Securities from "../pages/securities/securities";
import Listing from "../pages/issuer/listing/listing";

import AdcuCheckerReports from "../pages/checker/adcu-checker-reports/adcu-checker-reports";

import RRMakerReports from "../pages/maker/rr-maker-reports/rr-maker-reports";
import RRCheckerReports from "../pages/checker/rr-checker-reports/rr_checker-reports";

import Issuer_Reports from "../pages/issuer/issuer-reports/issuer-reports";
import Maker_Reports from "../pages/maker/ca-maker-reports/maker-reports";
import Checker_Reports from "../pages/checker/ca-checker-reports/checker-reports";

import AdcuMakerReports from "../pages/maker/adcu-maker-reports/adcu-maker-reports";

import WorkflowReports from "../pages/securities/workflow-reports/workflow-reports";

import ADCUSecurities from "../pages/adcu/adcu-securities/adcu-securities";
import SaAuthorizerDashboard from "../pages/sa-authorizer/sa-authorizer-dashboard/sa-authorizer-dashboard";

import IssuerListingCalendar from "../pages/issuer/issuer-listing-calendar/issuer-listing-calendar";
import AdcuListingCalendar from "../pages/adcu/adcu-listing-calendar/adcu-listing-calendar";

import {
  SELLING_AGENT_AUTHORIZER_ROLE,
  SELLING_AGENT_ROLE,
  ADCU_ROLE,
  ISSUER_ROLE,
  INVESTOR_ROLE, 
  BROKER_ROLE, 
  ADMIN_SPU_ROLE, 
  ADMIN_LISTING_OFFICER, 
  UNDERWRITER_ROLE,
  ADCU_CHECKER, 
  ADCU_MAKER,
  CA_CHECKER, 
  CA_MAKER,
  RR_MAKER,
  RR_CHECKER,
  SELLING_AGENT_REPORT
} from "../helpr/constants";

class UserService extends Service {

  constructor(unauthorized=false) {
    super("USER_SERVICE", unauthorized);
  }


  //TODO: REMOVE if(user?.attributes?.['custom:entity_id'] == "ef85ed16a4601f3665b1d9a1da8e07345ea8a1a4"){
  // if reports is fully deployed - Ian
  getUserModules = (role, user) => {
    switch(role){
      case SELLING_AGENT_ROLE:
        return [
          { path: '/securities', name: 'Securities', component: Securities, link: true, default: true }
        ]
      case SELLING_AGENT_AUTHORIZER_ROLE:
        return [
          { path: '/securities', name: 'Securities', component: SaAuthorizerDashboard, link: true, default: true },
        ]
      case SELLING_AGENT_REPORT:
        return [
          { path: '/tax-exempt-reports', name: 'Tax-Exempt Reports', component: WorkflowReports, link: true, default: true},
          { path: '/certification-of-holdings', name: 'Certification of Holdings', component: WorkflowReports, link: true, default: false}
        ]
      case ADCU_ROLE:
        return [
          { path: '/securities', name: 'Securities', component: ADCUSecurities, link: true, default: true },
          { path: '/registrations', name: 'Investor Registrations', component: AdminInvestorRegistrations, link: true, default: false },
          { path: '/listing-calendar', name: 'Listing Calendar', component: AdcuListingCalendar, link: true, default: false}
        ]
      case ISSUER_ROLE:
          if(user?.attributes?.['custom:entity_id'] == "ef85ed16a4601f3665b1d9a1da8e07345ea8a1a4"){
          return [
            { path: '/listing', name: 'Listing and Enrollment', component: Listing, link: true, default: true },
            { path: '/issuer_reports', name: 'Issuer Reports', component: Issuer_Reports, link: true, default: true },
            { path: '/listing-calendar', name: 'Listing Calendar', component: IssuerListingCalendar, link: true, default: false}
          ]
        }
        else{
          return [
            { path: '/listing', name: 'Listing and Enrollment', component: Listing, link: true, default: true },
            { path: '/listing-calendar', name: 'Listing Calendar', component: IssuerListingCalendar, link: true, default: false}
          ]
        }
        // return [
        //        { path: '/listing', name: 'Listing and Enrollment', component: Listing, link: true, default: true },
        //        { path: '/issuer_reports', name: 'Issuer Reports', component: Issuer_Reports, link: true, default: true },
        //        { path: '/listing-calendar', name: 'Listing Calendar', component: IssuerListingCalendar, link: true, default: false}
        //      ]
      case UNDERWRITER_ROLE:
        return [
          { path: '/listing', name: 'Listing and Enrollment', component: Listing, link: true, default: true }
        ]
      case INVESTOR_ROLE:
        return [
          { path: '/tf/:transferId', name: 'Transfers', component: TransferForm, link: true },
          { path: '/irf/:registrationId', name: 'Registrations', component: RegistrationForm , link: true }
        ]
      case BROKER_ROLE:
        return [
          { path: '/transfers', name: 'Transfer Instructions', component: Transfers, link: true, default: true },
          { path: '/registrations', name: 'Investor Registrations', component: InvestorRegistrations, link: true }
        ]
      case ADMIN_SPU_ROLE:
        return [
          { path: '/transfers', name: 'Transfers', component: AdminTransfers, link: true, default: true }
        ]
      case ADMIN_LISTING_OFFICER:
        return [
          { path: '/listing', name: 'Listing and Enrollment', component: AdminListing, link: true, default: true },
          { path: '/listing-calendar', name: 'Listing Calendar', component: AdminListingCalendar, link: true, default: false }
        ]
      case ADCU_MAKER:
        return [
          { path: '/tax-exempt-reports', name: 'Tax-Exempt Reports', component: AdcuMakerReports, link: true, default: true}
        ]
      case ADCU_CHECKER:
        return [
          {path: '/tax-exempt-reports', name: 'Tax-exempt Reports', component: AdcuCheckerReports, link: true, default: true}
        ]
      case CA_CHECKER:
        return [
          { path: '/checker_reports', name: 'Issuer Reports', component: Checker_Reports, link: true, default: true }
        ]
      case CA_MAKER:
        return [
          { path: '/security', name: 'Issuer Reports', component: Maker_Reports, link: true, default: true }
        ]
      case RR_CHECKER:
        return [
          { path: '/checker_reports', name: 'Adhoc Reports', component: RRCheckerReports, link: true, default: true}
        ]
      case RR_MAKER:
        return [
          { path: '/adhoc-reports', name: 'Adhoc Reports', component: RRMakerReports, link: true, default: true}
        ]
      default:
        return []
    }
  }

  registerUserAccess = (email, security) => {
    return this.post('/session', {}, {
      'email' : email,
      'id': security['id'],
      'applicationId': security['applicationId']
    });
  }

  getUserSession = (sessionId) => {
    return this.unauthenticatedGet(`/session/`,{
      'sessionId' : sessionId
    });
  }

  unregisterSession = (email, sessionId) => {
    return this.unauthenticatedPost(`/session/unregister`,{},
    {
      'email': email,
      'transactionId': sessionId
    })
  }

  getBatchInvitePresignedUrl = (id, applicationId, filename, type) => {
    return this.get(`/session/batch`, {
      id: id,
      applicationId: applicationId,
      filename: filename,
      type: type
    });
  }

  uploadBatchInviteList = (path, file) => {
    return this.unsignedPut(path, file, {
      headers : {
        'Content-Type' : 'text/csv'
      }
    });
  }

  getTrainingVideoUrl = () => {
    return this.get('/trainingvideo');
  }

  getApplicantTrainingVideoUrl = () => {
    return this.unauthenticatedGet('/trainingvideo');
  }
}

export default UserService


